<app-auth-layout>
  <header class="pb-16">
    <h1 class="text-4xl">
      {{ 'login.title' | translate }}
    </h1>
  </header>
  <div class="flex flex-col space-y-4">
    <div class="duration-slow flex w-full flex-col gap-3 transition-all">
      <button
        class="btn btn-primary mt-6 w-full rounded-md p-3"
        type="button"
        (click)="login()">
        {{ 'login.sso_submit' | translate }}
      </button>
    </div>
    <footer class="text-text-secondary flex flex-col gap-4 text-center text-xs"></footer>
  </div>
</app-auth-layout>

<!-- Support button -->
<a
  href="mailto:support@atoptima.com"
  class="hover:bg-interactive text-text-primary border-default bg-elevated duration-base fixed right-6 bottom-6 z-50 flex h-12 w-12 items-center justify-center rounded-full border shadow-sm transition-all">
  <i [class]="emailIcon" class="text-xl"></i>
</a>
